import React from 'react';
import { SwitchOffIcon, SwitchOnIcon } from 'assets/icons';
import { useMutation } from '@apollo/client';
import {
  ACTIVATE_COUPON,
  DEACTIVATE_COUPON
} from 'graphql/service';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const Slider = ({
  couponId,
  checked,
  setCoupons,
  left
}) => {

  const [activateCoupon] = useMutation(ACTIVATE_COUPON,
    {
      onCompleted: (data) => {
        setCoupons(prevCoupons => {
          return prevCoupons.map(coupon => {
            if(coupon.id === couponId) {
              return {
                ...coupon,
                isActive: true
              }
            }
            return coupon;
          });
        });
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const [deactivateCoupon] = useMutation(DEACTIVATE_COUPON,
    {
      onCompleted: (data) => {
        setCoupons(prevCoupons => {
          return prevCoupons.map(coupon => {
            if(coupon.id === couponId) {
              return {
                ...coupon,
                isActive: false
              }
            }
            return coupon;
          });
        });
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const handleToggle = () => {
    if(checked) {
      deactivateCoupon({
        variables: { 
          couponId: couponId
        }
      });
    } else {
      activateCoupon({
        variables: { 
          input: {
            couponId: couponId
          }
        }
      });
    }
  }

  return (
    <Container
      left={left}
    >
      <div
        className={`switch ${checked? 'active': ''}`}
        onClick={handleToggle}
      >
        <div className={`switchSlider ${checked? 'active': ''}`}>
          {checked? <SwitchOnIcon />: <SwitchOffIcon />}
        </div>
      </div>
      <div className={`switchText ${checked? 'active': ''}`}>
        {checked? 'ON': 'OFF'}
      </div>
    </Container>
  );
}

export default Slider;
